import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, injectIntl } from 'react-intl';
import NumberDataPod from '../../../components/NumberDataPod';

const messages = defineMessages({
  title: {
    id: 'hubs.profiles.average-class-size.title',
    defaultMessage: 'Average Classroom Size',
  },
  description: {
    id: 'hubs.profiles.average-class-size.description',
    defaultMessage: 'Average number of students in a given course or classroom',
  },
});

function AverageClassSize({ averageClassSize, intl, lastUpdated }) {
  const roundedValue = Math.round(averageClassSize);
  const title = intl.formatMessage(messages.title);

  return averageClassSize ? (
    <NumberDataPod
      header={title}
      footer={lastUpdated}
      ariaLabel={`${title}, ${roundedValue}`}
      content={{
        value: roundedValue,
        text: intl.formatMessage(messages.description),
      }}
    />
  ) : null;
}

export default injectIntl(AverageClassSize);

AverageClassSize.propTypes = {
  lastUpdated: PropTypes.string,
  averageClassSize: PropTypes.number,
  intl: PropTypes.object,
};
